import { PUBLISHER_TOKEN } from '@/constants/params';
import { isMobileDevice } from './device';
import type { CheckoutTheme, TemplateType } from '@/types/boot';
import { getCheckoutTemplate } from '@/templates/TemplateRegistry';

export const getPublisherToken = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const publisherToken = searchParams.get(PUBLISHER_TOKEN) || '';
  return publisherToken;
};

/**
 * ACDEV-27964 / ACDEV-29232: the Builder Super Admin "Game Name" override
 * (`boot.gameName`) wins wherever the checkout DISPLAYS the game/publisher
 * name — the player header, the Apple Pay fallback tab, and the Apple Pay
 * sheet company-name label. When the override is empty/absent we fall back to
 * the existing general name, preserving pre-override behavior byte-for-byte.
 */
export const resolveCheckoutGameName = (
  gameName: string | undefined,
  fallbackName: string | undefined
): string | undefined => {
  return gameName?.trim() || fallbackName || undefined;
};

/**
 * Thin adapter for non-React callers that already hold a `templateType`. The
 * actual decision lives on the template class (`shouldShowBackground`) so
 * leaves, hooks, skeletons and this util all get the same answer.
 */
export const hasPublisherHaveBackgroundImage = (
  checkoutTheme: CheckoutTheme | undefined,
  templateType: TemplateType
) => {
  const viewport = isMobileDevice() ? 'mobile' : 'desktop';
  return getCheckoutTemplate(templateType).shouldShowBackground(viewport, checkoutTheme);
};
